import { gql } from '@apollo/client';

export default gql`
    query iotAttributesQuery($type: String!, $id: ID!, $iotClassUri: String!) {
        result: iotAttributes(type: $type, id: $id, iotClassUri: $iotClassUri)
    }
`;
